"use strict";
var uncurryThisAccessor = require("../internals/function-uncurry-this-accessor");
var isObject = require("../internals/is-object");
var requireObjectCoercible = require("../internals/require-object-coercible");
var aPossiblePrototype = require("../internals/a-possible-prototype");
module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, "__proto__", "set");
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {
  }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : void 0);
